<div
  [ngClass]="{
    'border-[--input-active-border-color] active:outline active:outline-4 active:outline-[--switcher-selected-pressed-shadow-color]':
      !isDisabled && selected,
    'border-[--input-border-color] active:border-gray-500': !isDisabled && !selected,
    'border-[--input-disabled-border-color] bg-gray-50 text-gray-400': isDisabled,
    'active:bg-gray-100': !isDisabled,
  }"
  class="flex h-full cursor-pointer items-start gap-2 rounded-[--input-border-radius] border bg-white p-4 text-base font-medium"
>
  <span [attr.data-checked]="selected" [attr.data-disabled]="isDisabled" class="radio flex-shrink-0"></span>
  <ng-template [ngTemplateOutlet]="template || defaultLabel"></ng-template>
</div>

<ng-template #defaultLabel>
  <div>{{ label }}</div>
</ng-template>
